import HeroCrumbs from 'components/Sections/Hero/HeroCrumbs';
import { generateMetaTags } from 'helpers';
import { useAnimation } from 'hooks/useAnimation';
import { useRef } from 'react';
import Helmet from 'react-helmet';
import { useSelector } from 'react-redux';
import { selectPricingTags } from 'store/slices/PricingSlice';

const PricingHero = ({ title, desc, isLoading }) => {
    const container = useRef();
    const pricingTags = useSelector(selectPricingTags);

    useAnimation({
        items: ['.pricing-title .body1', '.pricing-title h1'],
        container,
        dependencies: [isLoading],
    });
    const metaTags = generateMetaTags(pricingTags?.tags, 'meta');
    const metaTitle = generateMetaTags(pricingTags?.tags, 'title');

    return (
        <>
            <Helmet title={metaTitle ? `${metaTitle}` : title} meta={metaTags} />
            <section ref={container} className="inner-container pricing-title">
                <HeroCrumbs page={title} />
                <h1>{title}</h1>
                <div className="body1">{desc}</div>
            </section>
        </>
    );
};

export default PricingHero;
